import { render } from "./IssueDetails.vue?vue&type=template&id=3d6d5ff8&scoped=true"
import script from "./IssueDetails.vue?vue&type=script&lang=js"
export * from "./IssueDetails.vue?vue&type=script&lang=js"

import "./IssueDetails.vue?vue&type=style&index=0&id=3d6d5ff8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1533455392/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6d5ff8"]])

export default __exports__